import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const LEGACY_STAFF_ROUTES = {
  'brand.apps.staff.jobs': 'brand.staff.jobs',
  'brand.apps.staff.members': 'brand.staff.members',
  'brand.apps.staff.pay': 'brand.staff.pay',
} as const

export const checkHestiaStaffFeatureFlag: HermesGuardFn = async (to) => {
  if (typeof to.name !== 'string' || !(to.name in LEGACY_STAFF_ROUTES)) {
    return undefined
  }

  if (useFeatureFlags().isEnabled('hermes.hestiaStaff')) {
    return undefined
  }

  return {
    name: LEGACY_STAFF_ROUTES[to.name as keyof typeof LEGACY_STAFF_ROUTES],
    params: { brandId: to.params.brandId },
  }
}
